import React from "react";
import { Link } from "react-router-dom";
import {
    RenderKilogramo,
    RenderNumber,
    RenderNumberPercentage,
} from "../../../../../../Utils/renderField/renderReadField";

// enlace es opcional: cuando se puede consultar de dónde salen los kg, la celda
// lleva al listado de tancadas; sin él se pinta como texto
const CeldaMateriaPrima = ({ valor, enlace }) => {
    const cantidad = <RenderKilogramo value={valor || 0} decimals={2} />;

    return (
        <td className="text-center text-nowrap">
            {enlace ? (
                <Link
                    to={enlace}
                    title="Ver las tancadas del turno"
                    className="cierre-turno__enlace-tancadas"
                >
                    {cantidad}
                </Link>
            ) : (
                cantidad
            )}
        </td>
    );
};

// El DRC es el del análisis del turno para el padre PT: queda pendiente mientras
// no se valide y vacío si el padre no tuvo cargas en el turno
const CeldaDrcTurno = ({ item }) => {
    let contenido = "—";

    if (item.drc_turno) {
        contenido = (
            <RenderNumberPercentage value={item.drc_turno} decimals={2} />
        );
    } else if (Number(item.kg_humedos_tancadas) > 0) {
        contenido = "Pendiente";
    }

    return <td className="text-center text-nowrap">{contenido}</td>;
};

// enlaceTancadasTurno lleva a todas las tancadas del turno, sin importar el
// padre PT de la fila, así que es el mismo para toda la tabla
export const PadresPTTable = ({ cierreTurnoForm, enlaceTancadasTurno }) => {
    const { totalesPadresPTConSobrantes, totalesProduccionConSobrantes } =
        cierreTurnoForm;

    return (
        <div className="new-table-wrapper mt-4">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th rowSpan={2} className="cell-border-right">
                            Producto padre
                        </th>
                        <th colSpan={3}>Materia prima</th>
                        <th colSpan={2}>Paletización</th>
                        <th rowSpan={2} className="cell-border-left">
                            Kg sobrantes
                        </th>
                        <th rowSpan={2} className="cell-border-left">
                            Total
                        </th>
                    </tr>
                    <tr>
                        <th>Kg húmedos</th>
                        <th>DRC</th>
                        <th>Kg secos</th>
                        <th>Pacas paletizadas</th>
                        <th>Peso pacas</th>
                    </tr>
                </thead>
                <tbody>
                    {totalesPadresPTConSobrantes.length === 0 && (
                        <tr>
                            <td colSpan={8} className="text-center">
                                No hay registros de producción
                            </td>
                        </tr>
                    )}
                    {totalesPadresPTConSobrantes.map((item) => {
                        return (
                            <tr key={item.padre_producto_terminado_id}>
                                <td className="text-center cell-border-right">
                                    {item.padre_producto_terminado_nombre}
                                </td>
                                <CeldaMateriaPrima
                                    valor={item.kg_humedos_tancadas}
                                    enlace={enlaceTancadasTurno}
                                />
                                <CeldaDrcTurno item={item} />
                                <CeldaMateriaPrima
                                    valor={item.kg_secos_tancadas}
                                    enlace={enlaceTancadasTurno}
                                />
                                <td className="text-center text-nowrap">
                                    <RenderNumber
                                        value={item.cantidad_pacas_paletizadas}
                                        decimals={2}
                                    />
                                </td>
                                <td className="text-center text-nowrap">
                                    <RenderKilogramo
                                        value={item.kg_pacas_paletizadas || 0}
                                        decimals={2}
                                    />
                                </td>
                                <td className="text-center text-nowrap cell-border-left">
                                    <RenderKilogramo
                                        value={item.kg_secos_sobrantes || 0}
                                        decimals={2}
                                    />
                                </td>
                                <td className="text-center text-nowrap cell-border-left">
                                    <RenderKilogramo
                                        value={item.kg_producidos || 0}
                                        decimals={2}
                                    />
                                </td>
                            </tr>
                        );
                    })}
                    <tr className="totales-row">
                        <td className="text-center font-weight-bold cell-border-right">
                            Totales:
                        </td>
                        <td className="text-center text-nowrap font-weight-bold">
                            <RenderKilogramo
                                value={
                                    totalesProduccionConSobrantes.kg_humedos_tancadas ||
                                    0
                                }
                                decimals={2}
                            />
                        </td>
                        <td />
                        <td className="text-center text-nowrap font-weight-bold">
                            <RenderKilogramo
                                value={
                                    totalesProduccionConSobrantes.kg_secos_tancadas ||
                                    0
                                }
                                decimals={2}
                            />
                        </td>
                        <td className="text-center text-nowrap font-weight-bold">
                            <RenderNumber
                                value={
                                    totalesProduccionConSobrantes.cantidad_pacas_paletizadas ||
                                    0
                                }
                                decimalScale={0}
                            />
                        </td>
                        <td className="text-center text-nowrap font-weight-bold">
                            <RenderKilogramo
                                value={
                                    totalesProduccionConSobrantes.kg_pacas_paletizadas ||
                                    0
                                }
                                decimals={2}
                            />
                        </td>
                        <td className="text-center text-nowrap font-weight-bold cell-border-left">
                            <RenderKilogramo
                                value={
                                    totalesProduccionConSobrantes.kg_secos_sobrantes ||
                                    0
                                }
                                decimals={2}
                            />
                        </td>
                        <td className="text-center text-nowrap font-weight-bold cell-border-left">
                            <RenderKilogramo
                                value={
                                    totalesProduccionConSobrantes.kg_producidos ||
                                    0
                                }
                                decimals={2}
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
